"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContainer = createContainer;

var _react = _interopRequireDefault(require("react"));

/* eslint-disable prefer-const */
var EMPTY = Symbol();

function createContainer(useHook) {
  var Context = /*#__PURE__*/_react["default"].createContext(EMPTY);

  function Provider(props) {
    var value = useHook(props.initialState);
    return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
      value: value
    }, props.children);
  }

  function useContainer(name) {
    var value = _react["default"].useContext(Context);

    if (value === EMPTY) {
      throw new Error("".concat(name, " must be used inside a OneConfigProvider."));
    }

    return value;
  }

  return {
    Provider: Provider,
    useContainer: useContainer
  };
}